<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-2">
        <span class="text-3xl">🔍</span>
        <span>深度类型解读</span>
      </h2>
      <p class="text-gray-600 text-lg">全面了解{{ typeName }}的特征</p>
    </div>

    <!-- 类型特征详解 -->
    <div 
      class="p-7 rounded-xl mb-6 border-2"
      :style="{
        background: `linear-gradient(135deg, ${typeColor}10, #ffffff)`,
        borderColor: typeColor + '30'
      }"
    >
      <h4 class="text-lg font-semibold mb-4 flex items-center gap-2" :style="{ color: typeColor }">
        <span>💡</span>
        <span>类型特征详解</span>
      </h4>
      <p class="text-base leading-loose text-gray-800 indent-8">
        {{ description }}
      </p>
    </div>

    <!-- 潜在挑战与建议 -->
    <div class="p-6 bg-red-50 rounded-xl border border-red-200">
      <h4 class="text-lg font-semibold text-red-600 mb-4 flex items-center gap-2">
        <span>⚠️</span>
        <span>潜在挑战与建议</span>
      </h4>
      <ul class="space-y-3">
        <li
          v-for="(challenge, index) in challenges"
          :key="index"
          class="flex items-start gap-3"
        >
          <div class="flex-shrink-0 w-6 h-6 bg-red-100 text-red-600 rounded-full flex items-center justify-center text-xs font-bold mt-0.5">
            !
          </div>
          <span class="text-sm leading-relaxed text-red-900">{{ challenge }}</span>
        </li>
      </ul>
      
      <!-- 应对建议 -->
      <div class="mt-4 pt-4 border-t border-red-200">
        <p class="text-sm text-red-800 leading-relaxed">
          <strong>💪 应对建议：</strong>认识到这些潜在挑战是成长的机会。通过有意识地培养相关能力，您可以在保持自身优势的同时，弥补可能的短板，实现更全面的发展。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 深度类型解读组件
 * 展示类型的详细描述和潜在挑战
 */
export default {
  name: 'DeepTypeAnalysis',
  props: {
    description: {
      type: String,
      required: true
    },
    challenges: {
      type: Array,
      required: true
    },
    typeName: {
      type: String,
      required: true
    },
    typeColor: {
      type: String,
      required: true
    }
  }
}
</script>

